module.exports = __webpack_public_path__ + "img/award-5.1bab8f18.png";